const lazyloadHelper = require('norska/frontend/algolia/lazyload');

module.exports = {
  img(item) {
    const options = {
      cloudinary: 'pixelastic-society',
      imoen: item.picture,
      uuid: item.objectID,
    };
    const img = lazyloadHelper.attributes(item.picture.url, options);

    return img;
  },
  displaySeasonIndex(item) {
    const seasonIndex = `${item.seasonIndex}`.padStart(2, '0');
    const scenarioIndex = `${item.scenarioIndex}`.padStart(2, '0');
    return `S${seasonIndex}E${scenarioIndex}`;
  },
  displayAuthors(item) {
    const authors = item.authors;
    const authorsLength = authors.length;
    if (authorsLength === 1) {
      return authors[0];
    }
    const lastAuthor = authors[authorsLength - 1];
    return (
      authors.slice(0, authorsLength - 1).join(', ') + ` and ${lastAuthor}`
    );
  },
  displayLevels(item) {
    const levels = item.levels;
    return `${Math.min(...levels)}-${Math.max(...levels)}`;
  },
  displayText(item) {
    return item.backcover.replace(/\n/g, '<br>');
  },
};
